module.exports = __webpack_public_path__ + "media/images/brands/marisol-b41f730d7470cb7be37bc69c10b462f0.png";